// extracted by mini-css-extract-plugin
module.exports = {"cardcustom":"card_cardcustom__2xZ6R","box-card":"card_box-card__2u3Ts"};